import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  segmentedControl: {
    borderRadius: 30,
    display: 'inline-flex',
    marginBottom: 30,
    overflow: 'hidden',
    width: 'fit-content',
    '@media(max-width: 560px)': {
      display: 'block',
      '& > div': {
        display: 'grid',
        width: '100%',
        gridTemplateColumns: 'auto auto auto'
      },

    },
  }
});
